import type { V1MoveCountMessageKey } from './v1-move-count.en'

/** V1 godown move bags + count a bay strings (Hindi), spread into hi.ts. The type forces every key in v1-move-count.en.ts. */
export const v1MoveCountHi: Record<V1MoveCountMessageKey, string> = {
  'store.v1.move.title': 'बोरियाँ दूसरी जगह रखें',
  'store.v1.move.scanPlace': 'नई जगह का लेबल स्कैन करें',
  'store.v1.move.placeFirst': 'पहले उस **नए खाने या जगह** का लेबल स्कैन करें जहाँ बोरियाँ रखनी हैं',
  'store.v1.move.onList': 'बदलनी हैं',
  'store.v1.move.from': '{place} से',
  'store.v1.move.confirm': 'बोरियाँ रख दीं',
  'store.v1.move.doneTitle': 'बोरियाँ नई जगह पर',
  'store.v1.move.doneLine': '**{count}** बोरी अब **{place}** पर',
  'store.v1.move.doneChip': 'गोदाम की सूची में अब ये नई जगह पर हैं',
  'store.v1.move.replace': 'फटी बोरी / टैग गायब',
  'store.v1.count.bayTitle': 'खाने की गिनती',
  'store.v1.count.scanPlace': 'जगह का लेबल स्कैन करें',
  'store.v1.count.placeFirst': 'पहले उस **खाने या जगह** का लेबल स्कैन करें जिसे गिनना है',
  'store.v1.count.asked': 'ऑफ़िस ने {count} गिनती माँगी है: एक चुनें',
  'store.v1.count.everyTag': 'यहाँ की **हर बोरी का टैग** एक-एक करके स्कैन करें',
  'store.v1.count.counted': 'गिनीं',
  'store.v1.count.band': '{grade} · {lot} · {n}/{m} मिलीं',
  'store.v1.count.short': '{n} कम',
  'store.v1.count.nothing': 'फ़ोन के हिसाब से यहाँ कोई बोरी नहीं',
  'store.v1.count.notExpected': '{count} टैग यहाँ के नहीं',
  'store.v1.count.extra': 'ये बोरियाँ कहीं और होनी चाहिए: {tags}',
  'store.v1.count.unknown': 'ये कोड गोदाम की बोरी नहीं हैं: {tags}',
  'store.v1.count.placeLabel': 'यह जगह का लेबल है। बोरियों के टैग स्कैन करें।',
  'store.v1.count.done': 'गिनती पूरी',
  'store.v1.count.doneMatch': 'गिनती मिल गई',
  'store.v1.count.doneSaved': 'गिनती सेव हुई',
  'store.v1.count.doneLine': '**{place}** पर {expected} में से **{seen}** बोरी मिलीं',
  'store.v1.count.chipMatch': 'गोदाम की सूची से मिलती है',
  'store.v1.count.chipMismatch': 'सूची से नहीं मिली: ऑफ़िस देखेगा',
  'store.v1.count.replace': 'यहाँ फटी बोरी / टैग गायब',
}
